var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "clearfix main_center" }, [
    _c("div", { staticClass: "top-content" }, [
      _c(
        "div",
        { staticClass: "left-navbar" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.backBtn } },
            [_vm._v("返回")]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "right-content" },
      [
        _c(
          "el-form",
          {
            ref: "form",
            staticClass: "form viewFormWrapper",
            attrs: { model: _vm.form, "label-width": "150px" },
          },
          [
            _c(
              "el-card",
              { staticClass: "box-card", style: { height: _vm.cardHight } },
              [
                _c(
                  "div",
                  {
                    staticClass: "clearfix",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [_c("span", [_vm._v("门禁出入记录")])]
                ),
                _c("div", { staticStyle: { display: "inline-flex" } }, [
                  _c("img", {
                    staticStyle: { width: "150px", height: "191px" },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "400px",
                        display: "inline-block",
                        "margin-left": "20px",
                      },
                    },
                    [
                      _c("p", [
                        _c("span", { staticStyle: { "font-size": "35px" } }, [
                          _vm._v(_vm._s(_vm.form.personName)),
                        ]),
                        _c("span", { staticStyle: { "margin-left": "20px" } }, [
                          _vm._v(_vm._s(_vm.form.personRoleName)),
                        ]),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "margin-left": "20px",
                              "font-size": "25px",
                            },
                          },
                          [_vm._v("【" + _vm._s(_vm.form.inoutFlagName) + "】")]
                        ),
                      ]),
                      _c("p", [_c("span", [_vm._v(_vm._s(_vm.form.idcard))])]),
                      _c("p", [
                        _c("span", [_vm._v("发生门禁：")]),
                        _c("span", [_vm._v(_vm._s(_vm.form.guardName))]),
                      ]),
                      _c("p", [
                        _c("span", [_vm._v("发生时间：")]),
                        _c("span", [_vm._v(_vm._s(_vm.form.createTime))]),
                      ]),
                      _c("p", [
                        _c("span", [_vm._v("人员体温：")]),
                        _c("span", [_vm._v(_vm._s(_vm.form.personTemp))]),
                      ]),
                    ]
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }